<template>
  <el-dialog
    :before-close="noDialog"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    title="更换提示"
  >
    <el-form
      ref="params"
      :model="params"
      :rules="paramsRules"
      label-width="auto"
    >
      <el-form-item label="更换类型">
        <el-radio-group v-model="typeRadio">
          <el-radio v-if="deviceVersions != '8'" :label="1"
            >更换硬件UID(4G模块)</el-radio
          >
          <el-radio :label="2">更换设备整机</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="更换原因">
        <el-radio-group v-model="changeRadio">
          <el-radio :label="1">损坏</el-radio>
          <el-radio :label="2">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="changeRadio === 2" label="解绑原因" prop="content">
        <el-input
          v-model="params.content"
          :autosize="{ minRows: 4, maxRows: 4 }"
          :style="{ width: '100%' }"
          placeholder="请输入解绑原因"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="typeRadio == 1 ? '硬件UID' : '主机二维码'"
        prop="ids"
      >
        <el-input v-model="params.ids" placeholder="请扫码更换">
          <template slot="append">
            <el-button plain type="success" @click="scanIds"
              >扫码更换</el-button
            >
          </template>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取 消</el-button>
      <el-button type="primary" @click="changePost">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import DeviceQRCodeController from "@/api/device/DeviceQRCodeController";
import agentChangeDevice from "@/api/device/charging-pile-manage/agentChangeDevice";
import agentChangeDeviceModule from "@/api/device/charging-pile-manage/agentChangeDeviceModule";
import agentGetDeviceInfoBySn from "@/api/device/charging-pile-manage/agentGetDeviceInfoBySn";
import dialogMixin from "@/mixin/dialogMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import scanMixin from "@/mixin/scanMixin";
import { Message } from "element-ui";

export default {
  name: "changeDialog",
  mixins: [dialogMixin, resDisposeMixin, scanMixin],
  props: {
    deviceId: Number,
    deviceVersions: String,
  },
  watch: {
    deviceId(newValue) {
      this.params.deviceId = newValue;
    },
    deviceVersions(newValue) {
      this.typeRadio = newValue == "8" ? 2 : 1;
    },
  },
  data() {
    return {
      paramsRules: {
        ids: [{ required: true, message: "请扫码获取IDS" }],
        content: {
          validator: (rule, value, callback) => {
            if (this.changeRadio === 2) {
              if (value === "" || value === undefined) {
                callback(new Error("请输入更换原因"));
              }
            } else {
              callback();
            }
          },
        },
      },
      changeRadio: 1,
      typeRadio: 1,
      params: {
        deviceId: undefined,
        content: undefined,
        ids: undefined,
      },
    };
  },
  methods: {
    changePost() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          if (this.changeRadio === 1) {
            this.params.content = "损坏";
          }
          if (this.typeRadio == 1) {
            // 更换4G模块
            agentChangeDeviceModule(this.params).then((res) => {
              this.resEditNoDialog({ res });
            });
          } else {
            // 更换设备整机
            agentChangeDevice(this.params).then((res) => {
              this.resEditNoDialog({ res });
            });
          }
        }
      });
    },
    scanIds() {
      this.scan({
        callBack: (res) => {
          const isLink = res.resultStr.substring(0, 4) === "http";

          // 更换uid
          if (this.typeRadio == 1) {
            if (isLink) {
              return this.$message.error("请扫4G模块的二维码~");
            }
            agentGetDeviceInfoBySn(
              btoa(unescape(encodeURIComponent(res.resultStr)))
            ).then((res) => {
              this.resDispose({
                res,
                success: () => {
                  this.params.ids = res.data.ids;
                },
              });
            });
          } else {
            // 更换整机
            if (!isLink) {
              return this.$message.error("请扫外部的主机二维码~");
            }
            let strList = res.resultStr.split("?");
            if (strList.length === 2) {
              let argList = strList[1].split("&");
              if (argList.length === 2) {
                if (argList[0] === "type=device") {
                  console.log(argList[1].split("=")[1]);
                  DeviceQRCodeController.getDeviceByCode(
                    argList[1].split("=")[1].substring(0, 32)
                  ).then((res) => {
                    this.resDisposeWithoutSuccessMsg({
                      res,
                      success: () => {
                        this.params.ids = res.data.ids;
                      },
                    });
                  });
                } else {
                  Message.error("二维码错误");
                }
              } else {
                Message.error("二维码错误");
              }
            } else {
              Message.error("二维码错误");
            }
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-radio {
  margin-bottom: 10px !important;
}
</style>
